type TierKey = string;

type Option<T extends TierKey> = { label: string; value: T };

export function TierFilterChips<T extends TierKey>({
  value,
  options,
  onChange,
}: {
  value: T;
  options: Option<T>[];
  onChange: (v: T) => void;
}) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 6,
        background: "var(--ant-color-bg-layout)",
        padding: 4,
        borderRadius: 999,
      }}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            style={{
              minHeight: 32,
              padding: "4px 14px",
              border: "none",
              borderRadius: 999,
              background: active ? "var(--ant-color-bg-container)" : "transparent",
              color: active ? "var(--ant-color-text)" : "var(--ant-color-text-secondary)",
              fontSize: 15,
              fontWeight: active ? 600 : 500,
              cursor: "pointer",
              boxShadow: active
                ? "0 1px 3px color-mix(in srgb, #000 8%, transparent)"
                : "none",
              transition: "background 0.15s ease, color 0.15s ease",
              whiteSpace: "nowrap",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
